import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Invoice from '../../../functions/logic/Invoice'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModalInvoice from '../../../components/FormModalInvoice'
import { useSnackbar } from 'notistack'

export default function Bodegas() {
    const [spiner, setSpiner] = useState(false)
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [dataInvoice, setDataInvoice] = useState([])
    const [isOpenModalform, setIsOpenModalForm] = useState(false)

    const columns = ['Número factura', 'Fecha emisión', 'Identificación', 'Cliente']

    const getInvoices = useCallback(async (page, perPage, param, search) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'mantenimiento'
        const response = await Invoice.getPendingInvoiceLogic(userToken, localStorage.getItem('paramModule').replace(/"/g, ''), 0, 'P', page, perPage, search)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        if (!response.error) {
            setdata(response["responseTableMapper"])
            setTotalRows(response.total_records)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
    }, [enqueueSnackbar, userToken])

    useEffect(() => {
        getInvoices(1, 5, param, 'no')
    }, [param, getInvoices])

    const handlePageChange = (page, perPage) => {
        setSpiner(true)
        getInvoices(page, perPage, param, 'no')
        setSpiner(false)
    }

    const handleSearch = (item) => {
        alert(item)
    }

    const handledVer = async (e) => {
        setSpiner(true)
        setIsOpenModalForm(true)
        const response = await Invoice.getPendingInvoiceLogic(userToken, localStorage.getItem('paramModule').replace(/"/g, ''), e.id, 'p', 1, 1, 'no')
        if (!response.responseResp.error) {
            setDataInvoice(response.responseData[0])
        }
        setSpiner(false)
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModalInvoice
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={'Factura'}
                button={''}
                formData={dataInvoice}
                handledSave={[]}
                opt={'Factura'}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                                onEdit={handledVer}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}




